"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNumberSeparators = exports.parseNumber = exports.formatNumberToParts = exports.formatNumber = exports.NumberFormatter = void 0;
const FormatterUtils_1 = require("../FormatterUtils");
const NumberUtils_1 = require("./NumberUtils");
const Number_types_1 = require("./Number.types");
class NumberFormatter {
    constructor(numberOptions) {
        this.formatter = (0, NumberUtils_1.getNumberFormatter)(numberOptions);
        this.percent = numberOptions === null || numberOptions === void 0 ? void 0 : numberOptions.percent;
    }
    formatNumber(value) {
        return (0, NumberUtils_1.formatNumberOrCurrency)(value, this.formatter, this.percent);
    }
    formatNumberToParts(value) {
        return this.formatter.formatToParts(Number((0, NumberUtils_1.transformPercentValue)(value, this.formatter, this.percent)));
    }
    parseNumber(value) {
        var _a, _b, _c;
        const control = this.formatNumberToParts(1e9 + 0.111);
        const group = (_a = control.find((prop) => prop.type === "group")) === null || _a === void 0 ? void 0 : _a.value;
        const decimal = (_b = control.find((prop) => prop.type === "decimal")) === null || _b === void 0 ? void 0 : _b.value;
        const percentSign = (_c = control.find((prop) => prop.type === "percentSign")) === null || _c === void 0 ? void 0 : _c.value;
        const converted = value
            .replace(new RegExp((0, FormatterUtils_1.escapeRegEx)(group), "g"), "")
            .replace(decimal, ".")
            .replace(percentSign, "")
            .replace(/\s/g, "");
        const parsed = parseFloat(converted);
        return this.percent === Number_types_1.Percent.DECIMAL ? parsed / 100 : parsed;
    }
    getNumberSeparators() {
        var _a;
        const parts = this.formatNumberToParts(1e9 + 0.1);
        return {
            decimal: (_a = parts.find((part) => part.type === "decimal")) === null || _a === void 0 ? void 0 : _a.value,
            group: parts.find((part) => part.type === "group").value,
        };
    }
}
exports.NumberFormatter = NumberFormatter;
function formatNumber(value, numberOptions) {
    const formatter = new NumberFormatter(numberOptions);
    return formatter.formatNumber(value);
}
exports.formatNumber = formatNumber;
function formatNumberToParts(value, numberOptions) {
    const formatter = new NumberFormatter(numberOptions);
    return formatter.formatNumberToParts(value);
}
exports.formatNumberToParts = formatNumberToParts;
function parseNumber(value, numberOptions) {
    const formatter = new NumberFormatter(numberOptions);
    return formatter.parseNumber(value);
}
exports.parseNumber = parseNumber;
function getNumberSeparators(locale) {
    const formatter = new NumberFormatter({ locale });
    return formatter.getNumberSeparators();
}
exports.getNumberSeparators = getNumberSeparators;
//# sourceMappingURL=NumberFormatter.js.map